import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { Notification, NotificationStatus, NotificationType } from '../../../lib/notification/notification';
import { queryKey } from './config';

type UseFetchNotificationsResponse = UseQueryResult & {
	notifications: Array<Notification>;
	unreadCount: number;
};

export const useFetchNotifications: (locale: string) => UseFetchNotificationsResponse = (locale: string) => {
	const http = useHttpClient();
	const query = useQuery([queryKey], () => http.get<{ result?: Array<NotificationResponse> }>('app_notifications/notifications'), {
		refetchOnWindowFocus: true,
		refetchInterval: 60 * 1000,
		select: (data) =>
			data.data?.result?.map(
				(notification) =>
					new Notification(
						notification._id,
						getStatus(notification),
						notification.type as NotificationType,
						notification.message,
						new Date(notification.created_at),
						notification.action,
						notification?.content,
						locale
					)
			) as Array<Notification>,
	});
	return {
		...query,
		notifications: query?.data?.sort((a, b) => b.createdDate.getTime() - a.createdDate.getTime()) ?? [],
		unreadCount: query.data?.filter((notification) => notification.status === NotificationStatus.Unread).length || 0,
	};
};

export interface NotificationResponse {
	_id: string;
	acted_at?: Date | null | string;
	channel?: string;
	message: string;
	seen_at?: Date | null | string;
	type: NotificationType | string;
	created_at: string;
	updated_at?: string;
	content?: object;
	action: string | null;
	user_id?: string;
}
const getStatus: (notification: NotificationResponse) => NotificationStatus = (notification) => {
	if (notification.acted_at) {
		return NotificationStatus.Read;
	}

	if (notification.seen_at) {
		return NotificationStatus.Seen;
	}

	return NotificationStatus.Unread;
};
